import { axios } from "../plugins/axios";
import { log } from "../plugins/helpers";

export default {
  namespaced: true,

  state: {
    survey_type: null, // initial_survey, final_survey
    initial_survey: null,
    final_survey: null
  },

  mutations: {
    SET_INITIAL_SURVEY(state, payload) {
      state.initial_survey = payload;
    },
    SET_FINAL_SURVEY(state, payload) {
      state.final_survey = payload;
    },
    SET_SURVEY_TYPE(state, payload) {
      state.survey_type = payload;
    }
  },

  actions: {
    setInitialSurvey({ commit }, payload) {
      commit("SET_INITIAL_SURVEY", payload);
    },
    setFinalSurvey({ commit }, payload) {
      commit("SET_FINAL_SURVEY", payload);
    },
    setSurveyType({ commit }, payload) {
      commit("SET_SURVEY_TYPE", payload);
    },

    finishSurvey({ state, commit, dispatch }) {
      if (state.survey_type === "initial_survey") {        
        dispatch('exam/preStartCheckLevelOne', null, { root: true })
      } else if (state.survey_type === "final_survey") {
        commit("SET_PAGE", "results", { root: true });
      }
    },

    async saveSurveyResults({ state, rootState, dispatch }, result) {
      try {
        let data = await axios.post(rootState.api.SAVE_SURVEY_RESULTS, {
          user_id: rootState.user_id,
          exam_id: rootState.exam_id,
          result: result.data,
          survey_type: state.survey_type
        });

        log("save survey success", data);
      } catch (error) {
        log("save survey error", error);
      }

      dispatch("finishSurvey");
    }
  }
};
